module.exports = __webpack_public_path__ + "assets/goals-mobile.09a0af3c07a53ca35a26fb0bf2cc86e6.png";